<style scoped>
  .jurisdiction{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;font-weight: bold;text-align: center;border-bottom: 1px solid #d7dde4;}
  .jurisdiction-list{font-size: 14px;color: #464c5b;line-height: 76px;height: 76px;text-align: center;border-bottom: 1px solid #d7dde4;}
  .tips-middle{display: inline-block;vertical-align:middle;line-height: 1em}
</style>

<template>
  <div>
    <!--分配权限-->
    <Modal
        v-model="editUserInfoPanel"
        title="编辑用户信息"
        width="700px"
        @on-ok="saveUserInfo"
        ok-text="保存"
    >
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">姓名：</Col>
        <Col span="7"><Input v-model="userInfoNow.name"></Input></Col>
        <Col span="4" style="text-align: right">电话号码：</Col>
        <Col span="7"><Input v-model="userInfoNow.mobile"></Input></Col>
      </Row>
      <div style="padding:10px"></div>
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">所属律所：</Col>
        <Col span="7">
          <Select v-model="userInfoNow.teamId" style="width:200px">
            <Option v-for="(item,index) in teamMap" :value="parseInt(index)" :key="index">{{item}}</Option>
          </Select>
        </Col>
        <Col span="4" style="text-align: right">权限组：</Col>
        <Col span="7">
          <Select v-model="userInfoNow.groupId" style="width:200px">
            <Option v-for="(item,index) in groupMap" :value="parseInt(index)" :key="index">{{item}}</Option>
          </Select>
        </Col>
      </Row>
      <div style="padding:10px"></div>
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">修改密码：</Col>
        <Col span="7"><Input type="password" v-model="userInfoNow.password" placeholder="不作修改"></Input></Col>
        <Col span="4" style="text-align: right">推荐人：</Col>
        <Col span="7" v-if="userList.length>0">
          <template v-if="userInfoNow.recommender">
            <p style="display: inline-block;vertical-align: middle">{{userList.find((secItem)=>{return secItem.id==userInfoNow.recommender}).name}}</p>
            <span style="color: #00a2e9;margin:0 10px;vertical-align: middle;cursor: pointer;" @click="userInfoNow.recommender=''">清空</span>
          </template>
          <userSelector
              style="display: inline-block"
              :userList="userList"
              @inputChange="getUserList($event)"
              @selected="userInfoNow.recommender = $event.id"
          >
            <template slot="title">
              <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>
            </template>
          </userSelector>
        </Col>
      </Row>
      <div style="padding:10px"></div>
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">角色状态：</Col>
        <Col span="7"><i-switch v-model="userInfoNow.state"></i-switch></Col>
      </Row>
    </Modal>
    <Row class="jurisdiction">
      <Col span="2">头像</Col>
      <Col span="3">姓名</Col>
      <Col span="3">电话号码</Col>
      <Col span="5">律所</Col>
      <Col span="2">权限组</Col>
      <Col span="3">申请时间</Col>
      <Col span="3">全部成员</Col>
      <Col span="3">操作</Col>
    </Row>
    <!--权限列表-->
    <Row class="jurisdiction-list" v-for="(item,index) in userList">
      <Col span="2">
        <p style="vertical-align: middle;">
          <Avatar v-if="item.icon" :src="item.icon" style="margin-right: 9px;"/>
          <Avatar v-else style="margin-right: 9px;">{{item.name[0]}}</Avatar>
        </p>
      </Col>
      <Col span="3"><p class="tips-middle">{{item.name}}</p></Col>
      <Col span="3"><p class="tips-middle">{{item.mobile}}&nbsp;</p></Col>
      <Col span="5"><p class="tips-middle">{{item.groupName}}&nbsp;</p></Col>
      <Col span="2"><p class="tips-middle">{{item.teamName}}&nbsp;</p></Col>
      <Col span="3"><p class="tips-middle">{{item.createDate}}</p></Col>
      <Col span="3" v-if="item.state">正常</Col>
      <Col span="3" v-else>禁用</Col>
      <Col span="3" style="color: #00a2e9;"><span style="cursor: pointer" @click="editUserInfo(item)">编辑</span> | <span @click="deleteUser(item.id)" style="cursor: pointer">删除</span></Col>
    </Row>
    <Row>
      <Col span="24" style="margin-top:40px;">
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getUserList()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getUserList()"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
  import UserSelector from "../../../components/system/userSelector";
  export default {
    name: "role",//角色权限
    components: {UserSelector},
    props:{
      createPanel:Boolean,
      searchText:String,
      searchTimes:Number,
    },
    data:function () {
      return {
        editUserInfoPanel:false,
        teamMap:{},
        groupMap:{},
        userList:[],
        userInfoNow:{},
        search:{
          pageSize: 15,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
      }
    },
    watch:{
      'createPanel':function (val) {
        this.editUserInfoPanel = val
        this.userInfoNow = {}
      },
      'searchText':function (val) {
        this.search.text = val
      },
      'searchTimes':function (val) {
        this.getUserList()
      },
      'createUserInfoPanel':function (val) {
        this.$emit('changePanelState',val)
      },
    },
    methods:{
      //删除用户
      deleteUser:function(id){
        var _this = this
        _this.send({
          headers:'P/UserDelete',
          confirm:true,
          data:{
            TargetId:id
          },
          success:function (res) {
            _this.getUserList()
            _this.$Notice.success({
              title:'系统提示',
              desc:'删除信息成功！'
            })
          }
        })
      },
      //打开修改用户信息面板
      editUserInfo:function(item){
        this.editUserInfoPanel = true
        this.userInfoNow = item
      },
      //获取用户列表
      getUserList:function () {
        var _this = this
        _this.send({
          headers:'U/UserList',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var userArr = []
            var i=0
            for(var index in res.List){
              userArr[i] = {}
              userArr[i].id = res.List[index].UserId
              userArr[i].icon = res.List[index].Icon
              userArr[i].name = res.List[index].UserName
              userArr[i].mobile = res.List[index].UserMobile
              userArr[i].state = Boolean(res.List[index].UserAble)
              userArr[i].groupId = res.List[index].PurviewId
              userArr[i].groupName = res.List[index].GroupName
              userArr[i].teamName = res.List[index].PurviewName
              userArr[i].teamId = res.List[index].GroupId
              userArr[i].createDate = res.List[index].RegisterTime
              userArr[i].recommender = res.List[index].WageFid
              i++
            }
            _this.search.total=res.Count
            _this.userList = userArr
          }
        })
      },
      //保存信息
      saveUserInfo:function(){
        var _this = this
        _this.send({
          headers:'P/UserPurview',
          data:{
            TargetId:_this.userInfoNow.id,
            UserName:_this.userInfoNow.name,
            UserMobile:_this.userInfoNow.mobile,
            UserAble:_this.userInfoNow.state?1:0,
            PurviewId:_this.userInfoNow.groupId,
            GroupId:_this.userInfoNow.teamId,
            PassWord:_this.userInfoNow.password,
            WageFid:_this.userInfoNow.recommender,
          },
          success:function () {
            _this.getUserList()
            _this.$Notice.success({
              title:'系统提示',
              desc:'更新信息成功！'
            })
          }
        })
      },
      //获取团队列表
      getTeamList:function () {
        var _this = this
        _this.send({
          headers:'T/GroupList',
          success:function (res) {
            for(var i in res){
              _this.teamMap[res[i].GroupId] = res[i].GroupName
            }
            console.log(res)
          }
        })
      },
      //获取用户组列表
      getGroupList:function () {
        var _this = this
        _this.send({
          headers:'P/PurviewList',
          success:function (res) {
            for(var i in res){
              _this.groupMap[res[i].PurviewId] = res[i].PurviewName
            }
          }
        })
      }
    },
    mounted:function () {
      this.getUserList()
      this.getGroupList()
      this.getTeamList()
    }
  }
</script>
